/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_DevicesInputs */

const en_pricing_feature_devices = /** @type {(inputs: Pricing_Feature_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile, desktop, and web apps`)
};

const es_pricing_feature_devices = /** @type {(inputs: Pricing_Feature_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apps para móvil, ordenador y web`)
};

/**
* | output |
* | --- |
* | "Mobile, desktop, and web apps" |
*
* @param {Pricing_Feature_DevicesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_devices = /** @type {((inputs?: Pricing_Feature_DevicesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_DevicesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_feature_devices(inputs)
	return en_pricing_feature_devices(inputs)
});